<p>home-input-slideshow works!</p>
